import { RefObject, useRef, useState } from 'react'

import useEffectOnce from './useEffectOnce'

type UseStickiness = (offset?: number) => {
  isSticky: boolean
  stickyRef: RefObject<any>
}

const useStickiness: UseStickiness = (offset) => {
  const [isSticky, setIsSticky] = useState(false)
  const stickyRef = useRef(null)

  useEffectOnce(() => {
    const refTop = offset || stickyRef.current.getBoundingClientRect().top

    const handleScroll = () => {
      setIsSticky(window.scrollY >= refTop)
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll, false)
    }
  })

  return { isSticky, stickyRef }
}

export default useStickiness
